import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HiOutlineShoppingBag,HiOutlineUser } from "react-icons/hi";
import defaultUser from "../../../assets/user.png";
import UserInfo from "./UserInfo";
import NavNotification from "./navNotification";
import Logo from "./Logo";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import MarketAveragePriceModal from '../../pages/MarketAveragePrice'
import GoogleTranslate from '../navbar/GglTranslator'


import { 
  useAuthContext,
  useCartContext,
  useWishlistContext,
} from "../../contexts";

import Search from "../filters/Search";
import commonObj from '../../../utils/Common';
import { positions } from "@mui/system";


const Navbar = () => {
  const { token, userInfo, logoutHandler } = useAuthContext();
  const [showModal, setShowModal] = React.useState(false);
  const [avgshowModal, setAvgShowModal] = React.useState(false);
  const { cart } = useCartContext();
  const { wishlist } = useWishlistContext();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const [colorChange, setColorChange] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorChange(true);
    } else {
      setColorChange(false);
    }
  };

useEffect(() => {
  const handleScroll = () => {
    setColorChange(window.scrollY >= 80);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    window.removeEventListener("scroll", handleScroll);
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


  const handleLogOut = () => {
    setLoggingOut(true);
    setTimeout(() => {
      logoutHandler();
      setLoggingOut(false);
    }, 1000);
  };

  const setLang = (ln) => {
    localStorage.setItem('defaultLang' , ln);
    window.location.reload();
  }
  
  const profileImg = userInfo?.photo!=''  ?  userInfo?.url+'/'+userInfo?.photo : defaultUser

  return (
  
    <nav
      className={`flex flex-col items-end py-3 max-w-screen mb-3 fixed left-0 right-0 px-[4%] md:px-[9%] bg-gray-200 ${
        colorChange ? "shadow-sm  drop-shadow-sm" : ""
      } z-10 transition delay-75 ease-in-out`}
    >
    <GoogleTranslate></GoogleTranslate>
    <div className="select_language2 " style={{position:'absolute',cursor:'pointer',top: 10+'px',color:'gray'}} > <span onClick={()=>setLang('en')}>EN</span> | <span onClick={()=>setLang('mo')}>MN</span> </div> 

      <div className="flex justify-between w-full items-center header_bottom">


        <section className="relative flex items-center logo-sec">
         
          <Link to="/">
          </Link>
         <Logo />
          
        </section>
        <div className="hidden  sm:block sm:w-1/3 relative topsearch">
          <Search />
        </div>
 
        <section className="flex items-center cartmenu-sec">

          {/* <Link
            to="/products"
            className="rounded-lg xl:h-10 flex items-center text-white justify-center h-12 px-4 mx-2 text-sm text-center  transition-colors duration-200 transform  xl:h-10 bg-green-500 hover:bg-green-600 focus:outline-none"
          >
            <span className=" xs:block">{commonObj.getLabel('Explore')}</span>{" "}
          
          </Link> */}
          <ul className=" hidden md:flex justify-between items-center justify-center text-2xl ps-1 cartmenu-div">
            {/* <li
              className="relative  text-white p-2 rounded-full bg-green-500 hover:bg-green-600 cursor-pointer mx-2 transition shadow-sm"
              onClick={() => navigate("/wishlist")}
            >
              <BsBookmarkHeart />
              {token && wishlist.length > 0 && (
                <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-green-500 hover:bg-green-600 border-2 border-[--theme-color] rounded-full -top-2 -right-2 ">
                  {wishlist.length}
                </div>
              )}
            </li> */}
            <li
              className="relative  text-white p-2 rounded-full bg-green-500 hover:bg-green-600 cursor-pointer mx-2 transition shadow-sm cartmenu-li"
              onClick={() => navigate("/cart")}
            >
              <HiOutlineShoppingBag />
              {token && cart.length > 0 && (
                <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-rose-600 border-2 border-[--theme-color] rounded-full -top-2 -right-2 ">
                  {cart.length}
                </div>
              )}
            </li>
            
         
       {token ? (
         <>
         <li className="relative  p-2 rounded-full bg-green-500 hover:bg-green-600 cursor-pointer mx-2 transition shadow-sm">
              <NavNotification userId={userInfo?.id} />
        </li>
    
  <section ref={menuRef} className="cursor-pointer relative profilemenu-sec">
        <div className="flex justify-center items-center space-x-3 cursor-pointer" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <div className="relative  text-white p-0 rounded-full bg-green-500 hover:bg-green-600 cursor-pointer mx-2 transition shadow-sm user_profile_name">
          { profileImg ? (
             <LazyLoadImage
             className="rounded-full"
             src={profileImg}
             alt="userProfileImage"
             width={40} 
             effect="blur"
             visibleByDefault={defaultUser}
             style={{height:40+'px'}}
          />
          ) : <HiOutlineUser />
          }
          </div>
          <div className="font-semibold dark:text-white text-gray-900 text-lg">
            <div className="cursor-pointer">  <div className="text-md user_pro_name">{userInfo?.firstName + ' ' + userInfo?.lastName}</div></div>
          </div>
        </div>
          
<div
  className={` bg-amber-50 absolute right-0 top-full mt-5 w-64 origin-top-right rounded-xl shadow-lg bg-[#e9e4d8] z-50 transform transition-all duration-400 ease-out will-change-transform ${
    isMenuOpen
      ? "opacity-100 translate-y-0 scale-100 visible"
      : "opacity-0 -translate-y-2 scale-95 invisible pointer-events-none"
  }`}
>
  <UserInfo logout={handleLogOut} />
</div>

          </section>



  
           </>
       ) : (
         <>     
      <li> 
      <Link to="/signup" className="flex items-center text-white justify-center h-12 px-4 mx-2 text-sm text-center text-gray-600 transition-colors duration-200 transform  rounded-lg xl:h-10 bg-gray-800 hover:bg-gray-700 focus:outline-none">
            {commonObj.getLabel('Ragister')}</Link> 
      </li> 
      <li> 
            <Link to="/login" className="flex items-center text-white justify-center h-12 px-4 mx-2 text-sm text-center text-gray-600 transition-colors duration-200 transform  rounded-lg xl:h-10 bg-gray-800 hover:bg-gray-700 focus:outline-none">
            {commonObj.getLabel('Login')}</Link> 
      </li>
      </>
        ) 
       }             
          </ul>
          {/*<section className="md:hidden cursor-pointer relative">
            <RxHamburgerMenu
              className="text-lg"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            />
            {isMenuOpen && <MenuDropdown navigate={navigate} />}
          </section>*/}
        </section>
  
      </div>

      <section className="mt-4 sm:hidden relative mob_search_bar">
        <Search />
      </section>
      {showModal ? (
        <>
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          >
            {/* <div className="relative w-auto my-6 mx-auto max-w-6xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold">
                    Modal Title
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                <div className="relative p-6 flex-auto">
                  <p className="my-4 text-slate-500 text-lg leading-relaxed">
                    I always felt like I could do anything. That’s the main
                    thing people are controlled by! Thoughts- their perception
                    of themselves! They're slowed down by their perception of
                    themselves. If you're taught you can’t do anything, you
                    won’t do anything. I was taught I could do everything.
                  </p>
                </div>
                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  <button
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div> */}
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}

        
          <MarketAveragePriceModal
            showModal={avgshowModal}
            setShowModal={setAvgShowModal}
          />
      
    </nav>
  );
};

export default Navbar;
